export default __webpack_public_path__ + "static/media/roy-cartoon-profile-200.1058a944.png";